import { __awaiter, __generator } from "tslib";
import { createDeprecatedSelectDriver } from '@wix/answers-ui-libby';
import { compKey } from './key';
export var createPublicMultilevelFieldDriver = function (wrapper) {
    var base = wrapper.$("." + compKey + "-wrapper");
    var createDeprecatedSelectDriverWithLevelNumber = function (levelNumber) { return createDeprecatedSelectDriver(base.$("." + compKey + "-level-" + levelNumber)); };
    return {
        getValueAtLevel: function (levelNumber) { return createDeprecatedSelectDriverWithLevelNumber(levelNumber).getSelectedValue(); },
        getPlaceholderAtLevel: function (levelNumber) { return createDeprecatedSelectDriverWithLevelNumber(levelNumber).getPlaceholder(); },
        openSelectAtLevel: function (levelNumber) { return createDeprecatedSelectDriverWithLevelNumber(levelNumber).openNonSearchSelection(); },
        selectValueAtLevelWithIndex: function (levelNumber, idx) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createDeprecatedSelectDriverWithLevelNumber(levelNumber).selectAtIndexNoSearch(idx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); },
        isErrorVisibleAtLevel: function (levelNumber) { return base.$("." + compKey + "-level-" + levelNumber).$(".error-msg-container").exists(); },
        isSelectExistsAtLevel: function (levelNumber) { return base.$("." + compKey + "-level-" + levelNumber).exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map